export interface OptionState {
    value: string;
    enabled: boolean;
}
